import { Geolocation } from "@capacitor/geolocation";

/**
 * Position coordinates from geolocation.
 */
export interface GeoLocationCoords {
  latitude: number;
  longitude: number;
  accuracy: number;
  altitude: number | null;
  altitudeAccuracy: number | null | undefined;
  heading: number | null;
  speed: number | null;
}

/**
 * Position result from geolocation.
 */
export interface GeoLocationPosition {
  coords: GeoLocationCoords;
  timestamp: number;
}

/**
 * Options for getCurrentPosition.
 */
export interface GetCurrentPositionOptions {
  enableHighAccuracy?: boolean;
  timeout?: number;
  maximumAge?: number;
}

/**
 * Gets the current device position.
 * On native platforms, uses the native geolocation API.
 * On web, uses the browser's geolocation API via Capacitor.
 *
 * Note: Unlike most adapters, we don't gate this on isNativePlatform() because
 * @capacitor/geolocation has built-in web support via the Web Geolocation API.
 *
 * @param options - Options for the geolocation request
 * @returns The current position
 */
export async function getCurrentPosition(
  options?: GetCurrentPositionOptions
): Promise<GeoLocationPosition> {
  // Note: Geolocation works on both native and web platforms
  // On web, it uses navigator.geolocation under the hood
  return await Geolocation.getCurrentPosition(options);
}
